import React, {useEffect, useState} from 'react';
import {toast} from "react-toastify";
import {DirectionService} from "../api/directionService";
import {DoctorService} from "../api/DoctorService";

const buttonStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    border: '1px solid #0502ae',
    borderRadius: '15px',
    background: '#0502ae',
    color: '#fff',
    padding: '5px 15px',
    cursor: 'pointer',
};

const SignatureHandler = ({clientId , signed}) => {
        const [signedFile, setSignedFile] = useState(null);

        useEffect(() => {
            // Завантажуємо скрипт `eusign.js` після монтування компонента
            const script = document.createElement('script');
            script.src = '/eusign.js'; // шлях до вашого скрипту в папці public
            script.async = true;
            script.onload = () => {
                const SIGN_WIDGET_PARENT_ID = 'sign-widget-parent';
                const SIGN_WIDGET_ID = 'sign-widget';
                const SIGN_WIDGET_URI = 'https://eu.iit.com.ua/sign-widget/v20240301_new/';

                // Ініціалізація EndUser
                window.euSign = new window.EndUser(
                    SIGN_WIDGET_PARENT_ID,
                    SIGN_WIDGET_ID,
                    SIGN_WIDGET_URI,
                    window.EndUser.FormType.ReadPKey
                );

                // Читання приватного ключа та налаштування слухача подій
                window.euSign.ReadPrivateKey()
                    .then(() => {
                        return window.euSign.AddEventListener(
                            window.EndUser.EventType.ConfirmKSPOperation,
                            onConfirmKSPOperation
                        );
                    })
                    .then(() => {
                        document.getElementById('qr-code-block').style.display = 'none';
                        document.getElementById('sign-widget-parent').style.display = 'none';
                        document.getElementById('sign-data-block').style.display = 'flex';
                        document.getElementById('sign-data-block').style.gap = '30px';
                    })
                    .catch((e) => {
                        alert('Виникла помилка при зчитуванні ос. ключа. Опис помилки: ' + (e.message || e));
                    });
            };

            document.body.appendChild(script);

            return () => {
                document.body.removeChild(script);  // Очищаємо скрипт при демонтажі компонента
            };
        }, []);

        // Функція для обробки підтвердження КСП операції
        const onConfirmKSPOperation = (event) => {
            const node = `<a href="${event.url}">
                    <img src="data:image/bmp;base64,${event.qrCode}" style="padding: 10px; background: white;">
                  </a>`;
            document.getElementById('qr-code-block').innerHTML = node;
            document.getElementById('qr-code-block').style.display = 'block';
        };

        // Функція для підписання файлу
    const onSign = async () => {
        try {
            const response = await DirectionService.getDirectionPdf(clientId);

            if (!response?.data) {
                alert('Файл для підписання не знайдено.');
                return;
            }
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const arrayBuffer = await blob.arrayBuffer();
            const fileUint8 = new Uint8Array(arrayBuffer);

            const asBase64String = true;
            const signAlgo = window.EndUser.SignAlgo.DSTU4145WithGOST34311;
            const signLevel = window.EndUser.PAdESSignLevel.PAdES_B_LTA;

            const signedData = await window.euSign.PAdESSignData(fileUint8, asBase64String, signAlgo, signLevel);

            if (!signedData) {
                alert('Не вдалося підписати файл.');
                return;
            }

            // Показати підписаний файл для завантаження
            const downloadLink = document.createElement('a');
            downloadLink.href = 'data:application/pdf;base64,' + signedData;
            downloadLink.download = 'signed_file.pdf';
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);

            // Конвертація base64 в File перед відправкою
            const base64ToFile = (base64Data, filename) => {
                const byteString = atob(base64Data);
                const ab = new ArrayBuffer(byteString.length);
                const ia = new Uint8Array(ab);
                for (let i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                return new File([ab], filename, { type: 'application/pdf' });
            };

            const file = base64ToFile(signedData, 'signed_file.pdf');

            const res = await DoctorService.sendSignedPdf(clientId, file);
            console.log('Файл успішно відправлений:', res);
            signed(true)

        } catch (error) {
            alert('Помилка під час підписання або відправлення файлу: ' + (error?.message || error));
            console.error(error);
        }
    };

    useEffect(() => {
            if (!!signedFile) {
                console.log(signedFile)
                const sendPDF = async() => {
                    try{
                        // const res = await DirectionService.sendDirectionPdf(14, signedFile);
                        // if (res?.data){
                        //     toast.success('Пдф відправлено');
                        // }
                    } catch(error){
                        toast.error('Помилка відправки Пдф');
                    }
                };

                sendPDF();
            }
        }, [signedFile]);


        return (
            <div>
                <div id="sign-widget-parent" style={{width: '50vw', height: '80vh'}}></div>
                <div id="qr-code-block" style={{display: 'none'}}></div>
                <div id="sign-data-block" style={{display: 'none'}}>
                    <button id="buttonSignData" onClick={onSign} style={buttonStyle}>
                        Підписати файл
                    </button>
                    {/* <button id="buttonSignData1" onClick={() => console.log(window.euSign)} style={buttonStyle}>
                        info
                    </button> */}
                </div>
            </div>
        );
    }
;

export default SignatureHandler;
